import React from 'react';
import { Box } from '@mui/material';

/**
 * Product thumbnail used in BAT Product Matching and Product Detail (unified).
 * Square frame, contain fit, border — same visual language as matching UI.
 */
export function ProductImageBox({ src, alt, size = 160 }) {
  if (!src) return null;
  return (
    <Box
      component="img"
      src={src}
      alt={alt || ''}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: 1,
        bgcolor: 'background.paper',
        display: 'block',
      }}
      onError={(e) => {
        e.target.style.display = 'none';
      }}
    />
  );
}

export default ProductImageBox;
